import { Moment } from 'moment-timezone';
import React, { createContext, useContext } from 'react';

/** Sub-tab when opening Payments → Transactions (URL unchanged). */
export type TransactionsListTab = 'all' | 'paid' | 'refunded';

export type PaymentsNav = {
    /**
     * Opens Transactions. Pass `refunded` from Commissions; default `paid` for sidebar / dashboard.
     * Bumps a remount counter so the list loads with the matching tab.
     * Optionally pass a date to filter transactions to that specific date.
     */
    openTransactions: (tab?: TransactionsListTab, date?: Moment, marketplaceIds?: number[]) => void;
};

const PaymentsNavContext = createContext<PaymentsNav | null>(null);

export const PaymentsNavProvider: React.FunctionComponent<{
    value: PaymentsNav;
    children: React.ReactNode;
}> = ({ value, children }) => <PaymentsNavContext.Provider value={value}>{children}</PaymentsNavContext.Provider>;

/** No provider outside Payments (e.g. Insights) — returns null. */
export const usePaymentsNavOptional = (): PaymentsNav | null => useContext(PaymentsNavContext);
